export const partnerTableColors = {
  border: '#d5e0eb',
  dark: '#173d61',
  focus: '#d5ad3f',
  hover: '#f6f9fc',
  soft: '#f6f9fc',
  gold: '#d5ad3f',
  text: '#10263d',
};

export const partnerFilterFieldSx = {
  width: '100%',
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#fff',
    borderRadius: '6px',
    fontSize: 12,
    minHeight: 40,
  },
  '& .MuiInputLabel-root': { fontSize: 12 },
};

export const partnerFilterButtonSx = {
  borderRadius: '6px',
  fontSize: 11,
  fontWeight: 700,
  height: 38,
  minWidth: 150,
  textTransform: 'none',
  width: { xs: '100%', sm: 150 },
};

export const partnerGroupButtonSx = {
  borderRadius: '6px',
  fontSize: 11,
  fontWeight: 700,
  minWidth: 90,
  textTransform: 'none',
};

export const partnerDataGridSx = {
  border: 0,
  color: partnerTableColors.text,
  fontFamily: "'DM Sans', sans-serif",
  fontSize: 12,
  '& .MuiDataGrid-cell': { borderColor: partnerTableColors.border },
  '& .MuiDataGrid-columnHeader': {
    backgroundColor: partnerTableColors.dark,
    color: '#fff',
    fontSize: 11,
    fontWeight: 700,
  },
  '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus': {
    outline: `2px solid ${partnerTableColors.focus}`,
    outlineOffset: '-2px',
  },
  '& .MuiDataGrid-columnSeparator, & .MuiDataGrid-sortIcon, & .MuiDataGrid-menuIconButton': {
    color: '#fff',
  },
  '& .MuiDataGrid-row:hover': { backgroundColor: partnerTableColors.hover },
  '& .MuiDataGrid-footerContainer': { borderColor: partnerTableColors.border },
  '& .partner-group-row': { backgroundColor: '#e8eef7' },
  '& .partner-group-row:hover': { backgroundColor: '#e8eef7' },
};

export const partnerTableSx = {
  minWidth: 980,
  '& .MuiTableCell-root': {
    borderColor: partnerTableColors.border,
    color: partnerTableColors.text,
    fontSize: 12,
    height: 48,
    py: 0.75,
  },
  '& .MuiTableHead-root .MuiTableCell-root': {
    backgroundColor: partnerTableColors.dark,
    color: '#fff',
    fontSize: 11,
    fontWeight: 700,
    textTransform: 'uppercase',
  },
  '& .MuiTableRow-hover:hover': { backgroundColor: `${partnerTableColors.hover} !important` },
  '& .MuiTableCell-root:focus-visible': {
    outline: `2px solid ${partnerTableColors.focus}`,
    outlineOffset: '-2px',
  },
};
